import { render, staticRenderFns } from "./CustormletterDia.vue?vue&type=template&id=a118ee84&scoped=true&"
import script from "./CustormletterDia.vue?vue&type=script&lang=js&"
export * from "./CustormletterDia.vue?vue&type=script&lang=js&"
import style0 from "./CustormletterDia.vue?vue&type=style&index=0&id=a118ee84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a118ee84",
  null
  
)

export default component.exports